import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import YoybuySpreadsheetGuide from "@/pages/article/yoybuy-spreadsheet-guide/page";
import YoybuyVsSuperbuy from "@/pages/article/yoybuy-spreadsheet-vs-superbuy/page";
import YoybuyDostavka from "@/pages/article/yoybuy-spreadsheet-dostavka/page";
import YoybuyKomissii from "@/pages/article/yoybuy-spreadsheet-komissii/page";
import YoybuyDlyaBiznesa from "@/pages/article/yoybuy-spreadsheet-dlya-biznesa/page";
import YoybuyOtzyvy from "@/pages/article/yoybuy-spreadsheet-otzyvy/page";
import YoybuyBezopasnost from "@/pages/article/yoybuy-spreadsheet-bezopasnost/page";
import YoybuyTamozhnya from "@/pages/article/yoybuy-spreadsheet-tamozhnya/page";
import YoybuyMassovyeZakupki from "@/pages/article/yoybuy-spreadsheet-massovye-zakupki/page";
import YoybuyKakVybratRazmer from "@/pages/article/yoybuy-spreadsheet-kak-vybrat-razmer/page";
import ShoppingGuide from "@/pages/article/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/yoybuy-spreadsheet-guide",
    element: <YoybuySpreadsheetGuide />,
  },
  {
    path: "/article/yoybuy-spreadsheet-vs-superbuy",
    element: <YoybuyVsSuperbuy />,
  },
  {
    path: "/article/yoybuy-spreadsheet-dostavka",
    element: <YoybuyDostavka />,
  },
  {
    path: "/article/yoybuy-spreadsheet-komissii",
    element: <YoybuyKomissii />,
  },
  {
    path: "/article/yoybuy-spreadsheet-dlya-biznesa",
    element: <YoybuyDlyaBiznesa />,
  },
  {
    path: "/article/yoybuy-spreadsheet-otzyvy",
    element: <YoybuyOtzyvy />,
  },
  {
    path: "/article/yoybuy-spreadsheet-bezopasnost",
    element: <YoybuyBezopasnost />,
  },
  {
    path: "/article/yoybuy-spreadsheet-tamozhnya",
    element: <YoybuyTamozhnya />,
  },
  {
    path: "/article/yoybuy-spreadsheet-massovye-zakupki",
    element: <YoybuyMassovyeZakupki />,
  },
  {
    path: "/article/yoybuy-spreadsheet-kak-vybrat-razmer",
    element: <YoybuyKakVybratRazmer />,
  },
  {
    path: "/article/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;